export default __webpack_public_path__ + "static/thinking-fast-and-slow-247dff9ee308b9834772d953656d0742.jpg";